import { tap } from "rxjs/operators";
import { Injectable } from "@angular/core";

import { ApicallOption, ApicallService } from "@core-services/apicall.service";

import { TellAFriend } from "@models/tell-a-friend";

import { Observable } from "rxjs";
import { Helper } from "@helpers/functions";

@Injectable({
	providedIn: "root"
})
export class InvitationService {
	private _taf: TellAFriend = new TellAFriend();

	public constructor(private apicallService: ApicallService) {}

	public get taf(): TellAFriend {
		return this._taf;
	}

	private clearTaf(): void {
		this.taf._note = "";
	}

	// TODO: eslint fix
	/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
	public tellAFriend(): Observable<any> {
		return this.apicallService.post("tellafriend/email", new ApicallOption(null, this.taf)).pipe(
			tap(
				() => {
					this.clearTaf();
				},
				(error) => Helper.handleError(error, this.taf)
			)
		);
	}
}
